import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BarChart2, Globe, Shield, TrendingUp } from 'lucide-react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1>About SwanPoint</h1>
          <p>Pioneering Quantitative Investment Strategies for a Dynamic World</p>
        </div>
      </section>

      <section className="overview-section">
        <div className="overview-content">
          <h2>Our Firm</h2>
          <p>SwanPoint is a cutting-edge quantitative investment management firm, founded in 2023. We combine advanced algorithms, machine learning, and deep financial expertise to deliver exceptional returns for our clients.</p>
        </div>
        <div className="overview-stats">
          <div className="stat-item">
            <h3>$200k+</h3>
            <p>Assets Under Management</p>
          </div>
          <div className="stat-item">
            <h3>3 Years</h3>
            <p>Market-Beating Performance</p>
          </div>
          <div className="stat-item">
            <h3>211.2%</h3>
            <p>Cumulative Return (Kleos Fund)</p>
          </div>
        </div>
      </section>

      <section className="mission-section">
        <h2>Our Mission</h2>
        <p>At SwanPoint, we're dedicated to revolutionizing investment management through the power of technology and data science. Our mission is to provide institutional and individual investors with innovative, high-performance investment solutions that navigate the complexities of global markets.</p>
      </section>

      <section className="approach-section">
        <h2>Our Approach</h2>
        <div className="approach-grid">
          {[
            { icon: <BarChart2 size={32} />, title: "Data-Driven Decision Making", description: "We leverage big data and advanced analytics to uncover unique investment opportunities and manage risk effectively." },
            { icon: <Globe size={32} />, title: "Global Perspective", description: "Our strategies span diverse markets and asset classes, capitalizing on global trends and regional dynamics." },
            { icon: <Shield size={32} />, title: "Risk Management", description: "Sophisticated risk models protect and grow our clients' assets across various market conditions." },
            { icon: <TrendingUp size={32} />, title: "Continuous Innovation", description: "We're constantly refining our algorithms and exploring new technologies to stay ahead of market trends." }
          ].map((item, index) => (
            <div key={index} className="approach-item">
              {item.icon}
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="products-section">
        <h2>Our Products</h2>
        <div className="products-grid">
          {[
            { name: "Kleos Alpha Fund", description: "Our flagship high-growth quantitative strategy, leveraging market inefficiencies for exceptional returns.", ytd: "5.88%", cumulative: "211.2%" },
            { name: "Prometheus Balanced Fund", description: "A balanced approach combining quantitative analysis with strategic asset allocation for stable growth.", ytd: "6.64%", cumulative: "77.8%" }
          ].map((product, index) => (
            <div key={index} className="product-item">
              <h3>{product.name}</h3>
              <p>{product.description}</p>
              <ul>
                <li>YTD Return: {product.ytd}</li>
                <li>2-Year Cumulative Return: {product.cumulative}</li>
              </ul>
            </div>
          ))}
        </div>
        <Link to="/portfolio" className="learn-more">Explore Our Strategies <ArrowRight size={16} /></Link>
      </section>

      <section className="cta-section">
        <h2>Partner with SwanPoint</h2>
        <p>Experience the future of investment management. Let us help you achieve your financial goals with our innovative strategies and personalized approach.</p>
        <Link to="/contact" className="cta-button">Get in Touch <ArrowRight size={20} /></Link>
      </section>
    </div>
  );
}

export default About;